// English names keep profile addresses stable when switching the display language.
export function memberSlug(member) {
  const info = member.attributes || member;
  const name = [info.name_en || info.name_th, info.surname_en || info.surname_th]
    .filter(Boolean).join(" ");
  const slug = name.normalize("NFKC").toLowerCase().trim()
    .replace(/[^\p{L}\p{N}]+/gu, "-").replace(/^-|-$/g, "");
  const reserved = ["search", "research", "publications", "team-members", "tools-and-services", "news-and-activities", "contact-us", "participate-and-donate", "data-document", "all-student"];
  return !slug || reserved.includes(slug) ? `member-${member.id}` : slug;
}

export const memberPath = (member) => `/${memberSlug(member)}`;

export async function loadMembers(signal) {
  const members = [];
  for (let page = 1; ; page += 1) {
    const response = await fetch(`https://nx.kmutt.ac.th/api/members?pagination[pageSize]=100&pagination[page]=${page}`, { signal });
    if (!response.ok) throw new Error(`Members API returned ${response.status}`);
    const body = await response.json();
    if (!Array.isArray(body.data)) throw new Error("Invalid members response");
    members.push(...body.data);
    if (page >= (body.meta?.pagination?.pageCount || 1)) return members;
  }
}
